/*
    form label notation:
        "form_label" + "category/entity" + <field name>
 */

export const resources = {
   en: {
      translation: {

         // ===== FORM LABELS ====

         form_label_general_first_name: 'First Name:',
         form_label_general_last_name: 'Last Name:',
         form_label_general_email: 'Email:',
         form_label_general_address: 'Address:',
         form_label_general_city: 'City:',
         form_label_general_state: 'State:',
         form_label_general_zip: 'Zip:',

         form_label_user_permission: 'Permission',

         form_label_autosearch_organization: 'Organization',
         form_label_autosearch_company: 'Hiring Company',

         form_label_job_group_name: 'Job Group Name',
         form_label_job_group_form: 'Form',
         form_label_job_group_publish: 'Publish Job Group',

         form_label_billing_credit_card_number: 'Credit Card Number:',
         form_label_billing_cvv: 'CVV:',
         form_label_expiration_month: 'Expiration Date:',
         form_label_expiration_year: '',
         form_label_billing_io_budget: 'IO Budget',
         form_label_billing_job_destination: 'Job Destination',
         form_label_billing_bid_strategy: 'Bid Strategy',
         form_label_billing_price: 'Price',
         form_label_billing_daily_budget: 'Daily Budget',
         form_label_billing_monthly_budget: 'Monthly Budget',
         form_label_billing_revshare: 'Revshare',
         form_label_job_group_keywords: 'Keywords',

         // ==== EOF FORM LABELS ====

         button_global_close: 'Close',
         button_global_cancel: 'Cancel',
         button_global_save: 'Save',
         button_global_save_changes: 'Save changes',

         billing_modal_add_credit_card_title: 'Add Credit Card',
         billing_modal_edit_credit_card_title: 'Edit Credit Card',

         company_list_title: 'Hiring Companies',

         company_details_contact_edit: 'edit contact info',
         company_details_contact_header: 'Contact Information',
         company_details_global_edit: 'edit',
         company_details_preview: 'preview',
         company_details_title: 'Company Details',

         company_details_about_us: 'About Us:',
         company_details_about_us_modal_title: 'About Us',
         company_details_about_us_description: 'What does your company do? What is your company mission?',
         company_details_look_for: 'What we look for:',
         company_details_look_for_modal_title: 'What we look for',
         company_details_look_for_description: 'Describe what your company is looking for in applicants.',
         company_details_culture_modal_title: 'Culture',
         company_details_culture_description: 'What makes your company unique? Is there a "feeling" to working here?',
         company_details_culture: 'Culture:',
         company_details_benefits: 'Benefits:',
         company_details_benefits_description: 'Do you provide medical and dental coverage? Is there vacation time?',
         company_details_other: 'Other:',
         company_urls_save_confirmation: 'Company social links saved successfully.',
         company_details_save_confirmation: 'Company details saved successfully.',
         company_details_contact_save_confirmation: 'Company updated successfully.',

         company_url_description: 'Websites & Social Media Links',
         company_url_text_twitter_with_colon: 'Twitter:',
         company_url_text_twitter: 'Twitter',
         company_url_text_twitter_add: 'Add Twitter',
         company_url_text_facebook_with_colon: 'Facebook:',
         company_url_text_facebook: 'Facebook',
         company_url_text_facebook_add: 'Add Facebook',
         company_url_text_yelp_with_colon: 'Yelp:',
         company_url_text_yelp_add: 'Add Yelp',
         company_url_text_yelp: 'Yelp',
         company_url_text_website_with_colon: 'Website:',
         company_url_text_website: 'Website',
         company_url_text_your_website: 'Your Website:',
         company_url_text_website_add: 'Add Website',

         company_settings_text: 'Hiring Company Settings',

         job_list_title: 'Jobs',
         job_create_title: 'Create Job',
         job_edit_title: 'Edit Job',
         job_create_organization_title: 'Organization',
         job_create_organization_field_title: 'Organization Name',
         job_create_company_title: 'Hiring Company',
         job_create_company_field_title: 'Hiring Company Name',
         job_create_job_group_title: 'Job Group',
         job_create_job_group_field_title: 'Job Group Name',
         job_create_job_group_detail_name: 'Job Group Title',
         job_create_job_group_detail_payout: 'Payout',
         job_create_job_group_detail_budget: 'Daily Budget',
         job_create_job_title: 'Job',
         job_create_label_job_title: 'Job Title',
         job_create_label_job_description: 'Job Description',
         job_create_label_job_suggestions: 'Job Description Templates',
         job_create_job_suggestion_show_more: 'more...',
         job_create_template_suggestions_modal_header: 'Job Template',
         job_create_template_suggestions_modal_paragraph: 'Our library of job descriptions consists of hundreds of templates. All of our job description templates are free, simple and easy to customize to meet your specifi needs. Just search for a job description template or selecte one from a category below, customize it or leave it as is, and publish your job.',
         job_create_template_suggestions_modal_list_title: 'Similar Job Title Templates',
         job_create_template_suggestions_modal_list_no_results: 'No results...',
         job_create_template_suggestions_modal_search_label: 'Search',
         job_create_template_suggestions_modal_template_heading: 'Job template Preview',
         job_create_job_destination_title: 'Job Destination',
         job_create_job_destination_paragraph: 'Traffic type for the job',
         job_create_job_destination_field_title: 'Traffic type',
         job_create_job_url_field_title: 'Destination Url',
         job_create_more_job_details: 'More Job Details',
         job_create_more_job_details_paragraph: 'Add important details to your job to receive <i>more</i> traffic and <i>better</i> candidates.',
         job_create_more_job_details_job_type_title: 'Employment Type',
         job_create_more_job_details_job_end_date_title: 'Job End In',
         job_create_more_job_details_job_end_date_field_title: 'Job End Date',
         job_create_more_job_details_compensation_title: 'Compensation',
         job_create_more_job_details_compensation_to_title: 'to',
         job_create_more_job_details_benefits_title: 'Benefits',
         job_create_more_job_details_benefits_medical_title: 'Medical Insurance',
         job_create_more_job_details_benefits_dental_title: 'Dental Insurance',
         job_create_more_job_details_benfits_visiion_title: 'Vision Insurance',
         job_create_more_job_details_benfits_life_title: 'Life Insurance',
         job_create_more_job_details_benfits_401_title: '401k',
         job_create_more_job_details_benfits_timeoff_title: 'Paid Time Off',
         job_create_more_job_details_require_resume_title: 'Require Resume',
         job_create_more_job_details_require_resume_detail: 'Only accept applications with a resume.',
         job_create_more_job_details_confidential_title: 'Confidential',
         job_create_more_job_details_confidential_detail: 'Make job confidential',
         job_create_more_job_details_confidential_field_title: 'Set Hiring Company Display Name',
         job_create_more_job_details_referenceid_title: 'Job Reference Id',
         job_create_more_job_details_direct_apply_title: 'Direct Apply Email',
         job_create_label_job_location: 'Location',
         job_create_job_location_paragraph: 'Enter the job\'s full address for better visibility. Some sources, such as Cragislist, display a map with your job.',
         job_create_job_location_full_address: 'Full Address or City and State',
         job_create_job_location_address_label: 'Address',
         job_create_job_location_city_label: 'City',
         job_create_job_location_state_label: 'State',
         job_create_job_location_zip_label: 'Zip',
         job_create_job_location_statewide: 'Statewide',
         job_create_job_location_nationwide: 'Nationwide',
         job_create_send_candidates_title: 'Email Candidates to Users',
         job_create_send_candidates_details: 'Select the account(s) of add the email addresses of the users who should receive email alerts for new candidates.',
         job_create_send_candidates_field_title: 'Email Addresses',

         job_group_modal_create_title: 'Create Job Group',
         job_group_modal_edit_title: 'Edit Job Group',
         job_group_list_card_title: 'Job Groups',
         job_group_table_header_company: 'Hiring Company',
         job_group_table_header_job_group: 'Job Group',
         job_group_table_header_delivery_status: 'Open/Close',
         job_group_table_header_active_jobs: 'Active Jobs',
         job_group_table_header_clicks: 'Clicks',
         job_group_table_header_candidates: 'Candidates',
         job_group_table_header_actions: 'Actions',

         user_role_user_label: 'Organization Full Access',
         user_role_user_description: 'Organization Full Access can view and edit all Career Pages, Jobs, and Candidates in all the Hiring Companies in your Organization.',
         user_role_comp_admin_label: 'Hiring Company Full Access',
         user_role_comp_admin_description: 'Hiring Company Full Access can view and edit the Career Pages, Jobs, and Candidates in the Hiring Companies assigned to them. Assign the Hiring Companies below.',
         user_role_comp_acct_label: 'Hiring Company Restricted',
         user_role_comp_acct_description: 'Hiring Company Restricted can view the Jobs and Candidates in the Jobs assigned to them. Assign the Hiring Companies below. You can then assign jobs to them in the Jobs page on the left hand side.',

         billing_page_credit_cards_title: 'Your credit and debit cards',
         billing_page_transactions_title: 'Recent Transactions',

         billing_page_billing_level_success: 'Billing Level updated successfully.',
         billing_page_billing_level_failure: 'Error switching billing level.',

         billing_page_assign_billing_profile_success: 'Company Assignments saved successfully.',
         billing_page_billing_billing_profile_failure: 'Error assigning companies.',

         candidate_list_title: 'Candidates',
         candidate_profile_resume_tab_content_no_resume_header: 'This candidate has not submitted a full resume yet',
         candidate_profile_resume_tab_content_no_resume_body: 'We have provided contact information for candidates that are in the process of completing their online resume or application with Upward.net. Upward.net sends resume requests and reminders to each applicant.',

         account_details_alert_candidate_tooltip: 'Receive an email when a candidate applies to a job in your hiring companies.',
         account_details_alert_billing_tooltip: 'Receive receipts and other credit card alerts for the jobs in your hiring companies.',
         account_details_alert_system_tooltip: 'Receive promotional emails, changes to your organization, or information about system outages.',
         account_details_alert_job_tooltip: 'Receive an alert when a job in your hiring company is opened, closed, etc.',

         /// transaction page
         transaction_page_title: 'Transactions',
      },
   },
};
